import axios from "axios";

import { ProcessEnrollmentRequestProto_Body } from "@noom/noom-contracts/noom_contracts/backend/enrollment/b2b/enrollment_event_service";
import { Api } from "@noom/noomscape";

import { captureException } from "@/utils/sentry";

// This is passed as an environment variable at build time,
// or when running locally from the .env file at the root of the project
const ANONYMOUS_CLIENT_TOKEN = process.env.HIVE_ANONYMOUS_CLIENT_TOKEN;

Api.register(
  "partner.processEnrollmentEvent",
  async (body: ProcessEnrollmentRequestProto_Body) => {
    if (!ANONYMOUS_CLIENT_TOKEN) {
      const error = new Error("ANONYMOUS_CLIENT_TOKEN is not set");
      if (process.env.NODE_ENV === "development") {
        // eslint-disable-next-line no-console
        console.error(error);
      } else {
        captureException(error);
      }
      throw error;
    }

    await axios({
      url: "/events/processEnrollmentEvent",
      urlWithPathParams: "/events/processEnrollmentEvent",
      baseURL: window.ENV.B2B_PARTNER_URL,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ANONYMOUS_CLIENT_TOKEN}`,
      },
      data: body,
    });
  },
);
